import { render, staticRenderFns } from "./BotaoProcessoDigital.vue?vue&type=template&id=00cfe9ea"
import script from "./BotaoProcessoDigital.vue?vue&type=script&lang=js"
export * from "./BotaoProcessoDigital.vue?vue&type=script&lang=js"
import style0 from "./BotaoProcessoDigital.vue?vue&type=style&index=0&id=00cfe9ea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports